// The email shape the sign-in dialog accepts (prototype/home/v1) and the
// server's normalization of account emails. Accounts are matched
// case-insensitively after trimming; NFC keeps visually equal addresses on one
// account and one throttle key.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;
const EMAIL_MAX_LENGTH = 254;

/** Untrusted input is cut to this before normalizing; room for whitespace around the longest valid email. */
export const EMAIL_INPUT_MAX_LENGTH = 320;

/** The dialog's check before sending: name@domain.tld. */
export function isEmailAddress(value: string): boolean {
  return EMAIL.test(value.trim());
}

export function normalizeEmail(value: string): string {
  return value.slice(0, EMAIL_INPUT_MAX_LENGTH).normalize("NFC").trim().toLowerCase();
}

/** A normalized email an account may have. */
export function isValidEmail(normalized: string): boolean {
  return normalized.length <= EMAIL_MAX_LENGTH && EMAIL.test(normalized);
}
